import { render, staticRenderFns } from "./AbstractDetails.vue?vue&type=template&id=15aae03e&scoped=true"
import script from "./AbstractDetails.vue?vue&type=script&lang=js"
export * from "./AbstractDetails.vue?vue&type=script&lang=js"
import style0 from "./AbstractDetails.vue?vue&type=style&index=0&id=15aae03e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15aae03e",
  null
  
)

export default component.exports